export const getRegion = async (): Promise<string> => {
  const res = await fetch("https://ipapi.co/json/");
  const data = (await res.json()) as { country_code: string };
  return data.country_code;
};
